import categories from './categories'
import documentTypes from './document-types'
import productTemplates from './product-templates'
import products from './products'
import providers from './providers'
import signatoryTypes from './signatory-types'
import signatureParameters from './signature-parameters'
import tags from './tags'

export default [
  {
    name: 'SettingsList',
    path: '/settings',
    component: () => import('pages/settings/SettingsList.vue')
  },
  ...categories,
  ...documentTypes,
  ...productTemplates,
  ...products,
  ...providers,
  ...signatoryTypes,
  ...signatureParameters,
  ...tags
]
